import * as Yup from "yup";

export const userValidate = Yup.object().shape({
  mobile: Yup.string()
    .min(11, "موبایل باید 11 رقمی باشد!")
    .max(11, "موبایل باید 11 رقمی باشد!")
    .required("وارد کردن موبایل الزامی است"),
  password: Yup.string()
    .min(5, "رمز عبور خیلی کوتاه است!")
    .max(48, "رمز عبور خیلی بلند است!")
    .required("وارد کردن رمز عبور الزامی است"),
  name: Yup.string().required("وارد کردن نام الزامی است"),
  nationalId: Yup.string().required("وارد کردن کد ملی الزامی است"),
});

export const editUserValidate = Yup.object().shape({
  mobile: Yup.string()
    .min(11, "موبایل باید 11 رقمی باشد!")
    .max(11, "موبایل باید 11 رقمی باشد!")
    .required("وارد کردن موبایل الزامی است"),
  name: Yup.string().required("وارد کردن نام الزامی است"),
  nationalId: Yup.string().required("وارد کردن کد ملی الزامی است"),
});

